// src/utils/severityUtils.ts

export const getSeverityColorClass = (severity: string): string => {
  if (!severity) return 'severity-unknown';
  const lowerSeverity = severity.toLowerCase();
  switch (lowerSeverity) {
    case 'debug': return 'severity-debug';
    case 'info': return 'severity-info';
    case 'warn': return 'severity-warn';
    case 'error': return 'severity-error';
    case 'fatal': return 'severity-fatal';
    default: return 'severity-unknown';
  }
};